module.exports = __webpack_public_path__ + "img/hospitium-10.dad1184d.jpg";